import React from 'react';
import TextMessenger from './TextMessenger/index';
import './assets/fonts/main-font.woff2';
import "./index.scss";

function App() {
  return (
    <div className="textingApp">
      <TextMessenger />
    </div>
  )
}

export default App;
